import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-foundation';
import type { PeriodParity } from 'lumen/models/period';
import {
  MEALTYPE_ICONS,
  type MealTypeValues,
  MEMBERSHIPTYPES,
  RATE_PARAMS,
  type RateParam,
  THIRD_PARTY_LABEL,
} from 'lumen/utils/constants/general-constants';

interface GeneralParityIconsSignature {
  Args: {
    mealType: MealTypeValues;
    parity: PeriodParity | undefined;
    rateParam: RateParam;
    showMemberRate: boolean;
  };
}

export default class GeneralParityIcons extends Component<GeneralParityIconsSignature> {
  get parityIcons(): IconName[] {
    if (!this.args.parity) {
      return [];
    }

    const {
      mealtype_included: mealType,
      membershiptype: membershipType,
      best_flex: bestFlex,
      labels,
    } = this.args.parity;

    const icons: IconName[] = [];
    if (labels?.includes(THIRD_PARTY_LABEL)) {
      icons.push('rates-third-party');
    } else if (this.args.rateParam !== RATE_PARAMS.BEST_FLEX && bestFlex) {
      icons.push('rates-best-flex');
    }

    if (
      !this.args.showMemberRate &&
      membershipType !== MEMBERSHIPTYPES.PUBLIC
    ) {
      icons.push('user');
    }

    if (this.args.mealType !== mealType && MEALTYPE_ICONS[mealType]) {
      icons.push(MEALTYPE_ICONS[mealType]);
    }

    return icons;
  }

  <template>
    <div class="flex gap-100 {{if this.parityIcons.length 'ml-100' 'ml-500'}}">
      {{#each this.parityIcons as |icon|}}
        <PrismIcon @name={{icon}} @size="small" />
      {{/each}}
    </div>
  </template>
}
